import { createReducer } from "@reduxjs/toolkit";
import {
  FETCH_AVAILABILITY_RECORDS_SUCCESS,
  ADD_AVAILABILITY_RECORD_SUCCESS,
  DELETE_AVAILABILITY_RECORD_SUCCESS,
  ADD_AVAILABILITY_RECORD_FROM_EVENT_STREAM_SUCCESS,
  EDIT_AVAILABILITY_RECORD_FROM_EVENT_STREAM_SUCCESS,
  DELETE_AVAILABILITY_RECORD_FROM_EVENT_STREAM_SUCCESS,
} from "~/store/action_types";

const availability_records = createReducer({}, (builder) => {
  builder
    .addMatcher(
      (action) =>
        [DELETE_AVAILABILITY_RECORD_FROM_EVENT_STREAM_SUCCESS, DELETE_AVAILABILITY_RECORD_SUCCESS].includes(
          action.type
        ),
      (state, action) => {
        const { id } = action;
        if (id) {
          const { [id]: _deleted, ...rest } = state;
          return rest;
        }
        return state;
      }
    )
    .addMatcher(
      (action) =>
        [
          EDIT_AVAILABILITY_RECORD_FROM_EVENT_STREAM_SUCCESS,
          ADD_AVAILABILITY_RECORD_FROM_EVENT_STREAM_SUCCESS,
          FETCH_AVAILABILITY_RECORDS_SUCCESS,
          ADD_AVAILABILITY_RECORD_SUCCESS,
        ].includes(action.type),
      (state, action) => {
        const { response = {} } = action;
        const { entities = {} } = response;
        const { availability_records } = entities;

        return {
          ...state,
          ...availability_records,
        };
      }
    );
});

export default availability_records;
